export const createGetUserSettingsRequest = (disableLoading = false) => {
    return {
        url: "/user_settings",
        method: "GET",
        disableLoading,
    };
}

export const createSaveUserSettingsRequest = (userSettings) => {
    return {
        url: "/user_settings",
        method: "POST",
        data: userSettings,
    };
}

export const createUpdateUserSettings = (id, userSettings) => {
    return {
        url: "/user_settings/" + id,
        method: "PUT",
        data: userSettings,
    };
}
